import styled from 'styled-components';
import { colors, radius } from '@ardoq/design-tokens';
import { withBasePath } from '../basePath';
import { DEFAULT_ARDOQ_I18NLOCALE, t, type I18nLocale } from '@ardoq/i18n';

type ApiErrorProperties = {
  errorMessage?: string;
  context?: string;
  i18nLocale?: I18nLocale;
};

const AuthErrorContainer = styled.div`
  font-family: Helvetica, sans-serif;
  display: flex;
  align-content: center;
  justify-content: center;
  background-color: ${colors.surfaceDefault};
  border-radius: ${radius.r8};
  padding: 1rem;
  z-index: 1051;
  width: 900px;
  margin: auto;

  .authErrorText {
    padding: 5rem;

    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;

    h1 {
      margin-bottom: 16px;
      font-weight: 600;
      letter-spacing: 2px;
    }

    p {
      font-size: 14px;
      font-weight: 400;
      color: ${colors.grey950};
    }
  }
`;

const DarkBackground = styled.div`
  height: 100%;
  display: flex;
  background-color: ${colors.surfaceBrand};
`;

const ApiError = ({
  errorMessage,
  context,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
}: ApiErrorProperties) => (
  <DarkBackground>
    <AuthErrorContainer id="authError">
      <div className="authErrorText">
        <h1 className="formTitle">
          {t(i18nLocale, 'auth:apiError.title', 'Oh, snapper!')}
        </h1>
        <p>
          {t(
            i18nLocale,
            'auth:apiError.bodyPrefix',
            'The application failed to load. Please check back in a few minutes, or '
          )}
          <a href="https://ardoq.com/status/">
            {t(
              i18nLocale,
              'auth:apiError.statusPageLink',
              'have a look at the status page'
            )}
          </a>
          {t(i18nLocale, 'auth:apiError.bodySuffix', ' if the error persists.')}
        </p>
        {context && (
          <p>
            {t(
              i18nLocale,
              'auth:apiError.context',
              { context },
              'Context: {{context}}'
            )}
          </p>
        )}
        {errorMessage && <p>{errorMessage}</p>}
        <p>
          {t(
            i18nLocale,
            'auth:apiError.supportPrefix',
            'For urgent matters, please contact '
          )}
          <a href="mailto:support@ardoq.com">
            {/* i18n-ignore-next-line */}
            support@ardoq.com
          </a>
          {t(i18nLocale, 'auth:apiError.supportSuffix', '.')}
        </p>
      </div>
      <div>
        <img src={withBasePath('/img/vikingtransparent.png')} alt="" />
      </div>
    </AuthErrorContainer>
  </DarkBackground>
);

export { ApiError };
